import React, { useEffect, useRef, useState } from "react";
import { apiRequest } from "../lib/api";
import { createFeedbackSubmissionId, getFeedbackSessionId } from "../lib/feedbackSession";
import { watchFeedback } from "../lib/feedbackNotifications";

export function FeedbackThread({ post, onUpdate, tracked = false }) {
  const container = useRef(null);
  useEffect(() => {
    if (!tracked || typeof IntersectionObserver === "undefined") return;
    const observer = new IntersectionObserver(entries => {
      if (document.visibilityState !== "hidden" && entries.some(entry => entry.isIntersecting)) {
        watchFeedback(post, true); observer.disconnect();
      }
    }, { threshold: 0.1 });
    if (container.current) observer.observe(container.current);
    return () => observer.disconnect();
  }, [post, tracked]);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submission = useRef(null);
  const locked = useRef(false);
  const send = async event => {
    event.preventDefault();
    if (locked.current) return;
    locked.current = true; setBusy(true); setError("");
    if (!submission.current) submission.current = createFeedbackSubmissionId();
    try {
      const result = await apiRequest(`/api/theofast/feedback/${post.id}/replies`, { method: "POST", body: JSON.stringify({ message, sessionId: getFeedbackSessionId(), submissionId: submission.current }) });
      watchFeedback(result.post, true); onUpdate(result.post);
      setMessage(""); setOpen(false); submission.current = null;
    } catch (err) { setError(err.message); }
    finally { locked.current = false; setBusy(false); }
  };
  return <div className="feedback-thread" ref={container}>
    {post.adminReply?.message && <div className="feedback-admin-reply"><strong>Admin</strong><p>{post.adminReply.message}</p></div>}
    {(post.replies || []).map((reply, index) => <div className="feedback-admin-reply" key={index}>
      <strong>{reply.role === "admin" ? "Admin" : reply.authorLabel}</strong>{" "}
      <time dateTime={reply.createdAt}>{new Date(reply.createdAt).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })}</time>
      <p>{reply.message}</p>
    </div>)}
    <button className="feedback-back" type="button" aria-expanded={open} onClick={() => setOpen(!open)}>{open ? "Cancel reply" : "Reply"}</button>
    {open && <form className="feedback-reply-form" onSubmit={send}>
      <label htmlFor={`reply-${post.id}`}>Your reply</label>
      <textarea id={`reply-${post.id}`} value={message} onChange={event => setMessage(event.target.value)} minLength={2} maxLength={2000} required disabled={busy} rows={3} />
      <button className="feedback-more" type="submit" disabled={busy}>{busy ? "Sending…" : "Send reply"}</button>
      {error && <p className="feedback-error" role="alert">{error}</p>}
    </form>}
  </div>;
}
